import React from 'react';
import background from '../../assets/co2.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoComposition extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="ATMOSPHERE"
        description="Composition"
        paragraph="By volume, dry air contains 78.08% nitrogen, 20.95% oxygen, 0.93% argon, 0.04% carbon dioxide, and small amounts of other gases."
        background={background}
     />
  
  );
 }
}   

export default InfoComposition;